// extracted by mini-css-extract-plugin
module.exports =  {"root":"xSQujs","contentContainer":"q7b0zc"};